var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgScience = function SvgScience(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 79,
    viewBox: "0 0 70 79",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wissenschaftler") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with Sketch.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#183E62",
    strokeWidth: 2,
    d: "M67.36 61.683 49.57 33.334V10.625h1.215c2.019 0 3.643-1.61 3.643-3.61V4.61c0-2-1.624-3.609-3.643-3.609H19.213c-2.019 0-3.643 1.61-3.643 3.61v2.406c0 2 1.624 3.609 3.643 3.609h1.214v22.709L2.637 61.683C-1.808 68.766 3.322 78 11.76 78h46.478c8.454 0 13.57-9.249 9.122-16.317ZM22 49l7.286-11.822c.56-.792.877-1.767.877-2.803V10h9.674v24.375c0 1.051.333 2.01.877 2.803L48 49z"
  })));
};
export default SvgScience;